import { SearchFiltersResponse } from 'components/discovery/plp/filters/plp-filters/typing/filters-typing.js'
import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export const FILTERS_SEARCH_FILTERS_API = Symbol('FILTERS_SEARCH_FILTERS_API')

export class FiltersSearchRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = { Accept: 'application/json' }
  controller: AbortController = new AbortController()

  constructor(searchEndpoint: string, baseUrl?: string) {
    this.endpointUrl = new URL(searchEndpoint, baseUrl || window.location.href)
  }
}

export interface FiltersSearchAPI {
  fetchFilters(request: FiltersSearchRequest): Promise<SearchFiltersResponse | null>
}

export const fakeSearchFiltersResponse: SearchFiltersResponse = {
  total_found: 68,
  search_term: null,
  suggested_search_term: null,
  search_filters: {
    tree_id: 18,
    brand_id: 0,
    tag_id: 0,
    product_type_id: 0,
    variant_id: 0,
    in_stock: false,
    is_device: false,
    is_favourite: false,
  },
  selected_filters: [],
  trees: [
    {
      id: 32,
      name: 'Machines',
      slug: 'machines',
      api_link: '/nl_NL/api/v1/search/?tree_id=32',
      page_link: '/nl_NL/machines/32/',
      count: 31,
    },
    {
      id: 33,
      name: 'Tools',
      slug: 'gereedschap',
      api_link: '/nl_NL/api/v1/search/?tree_id=33',
      page_link: '/nl_NL/gereedschap/33/',
      count: 21,
    },
  ],
  brands: [
    {
      id: 1,
      slug: 'cloudsuite',
      name: 'CloudSuite',
      count: 42,
      selected: false,
      api_link: '/nl_NL/api/v1/search/?tree_id=18&v=1-1',
      sequence: 1000000,
    },
    {
      id: 3,
      slug: 'a-brand',
      name: 'A Brand',
      count: 6,
      selected: false,
      api_link: '/nl_NL/api/v1/search/?tree_id=18&v=1-3',
      sequence: 1000000,
    },
  ],
  attributes: [
    {
      id: 4,
      display_mode: 'color',
      type: 'list',
      name: 'Kleurgroep',
      description: 'DIT IS EEN TEST VOOR REMCO',
      values: [
        {
          id: 14,
          count: 1,
          name: 'Beige',
          description: '',
          picture: '',
          css_color: '#F5F5DC',
          api_link: '/nl_NL/api/v1/search/?tree_id=18&v=2-4-14',
          selected: false,
        },
        {
          id: 13,
          count: 10,
          name: 'Blauw',
          description: '',
          picture: '',
          css_color: '#0000FF',
          api_link: '/nl_NL/api/v1/search/?tree_id=18&v=2-4-13',
          selected: false,
        },
      ],
    },
  ],
}

@registerDependency(FAKE, FILTERS_SEARCH_FILTERS_API)
export class FakeFiltersSearchService implements FiltersSearchAPI {
  requests: FiltersSearchRequest[] = []
  delay = 300
  held = false

  private isExternalUrl(url: URL): boolean {
    const hostname = url.hostname
    return hostname !== 'localhost' && hostname !== '127.0.0.1'
  }

  async fetchFilters(request: FiltersSearchRequest): Promise<SearchFiltersResponse | null> {
    this.requests.push(request)

    if (this.isExternalUrl(request.endpointUrl)) {
      try {
        const response = await fetch(request.endpointUrl, {
          method: request.method,
          headers: request.headers,
          signal: request.controller.signal,
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        return (await response.json()) as SearchFiltersResponse
      } catch {
        return null
      }
    }

    if (this.held) {
      // ponytail: blocks forever — lets tests assert on request count without merge() firing mid-test
      await new Promise(() => {})
    }
    // ponytail: intentional delay — keeps searchIsLoading=true long enough for the loading-state test assertion
    await new Promise(resolve => setTimeout(resolve, this.delay))
    return fakeSearchFiltersResponse
  }
}

@registerDependency(REAL, FILTERS_SEARCH_FILTERS_API)
export class RealFiltersSearchService implements FiltersSearchAPI {
  requests: FiltersSearchRequest[] = []

  async fetchFilters(request: FiltersSearchRequest): Promise<SearchFiltersResponse | null> {
    this.requests.push(request)

    try {
      const response = await fetch(request.endpointUrl, {
        method: request.method,
        headers: request.headers,
        signal: request.controller.signal,
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const apiResult = (await response.json()) as SearchFiltersResponse
      return apiResult
    } catch {
      return null
    }
  }
}
